<div class="access-detail-mail">
  <div class="header">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor mb-5"
        *ngIf="stepper > 1"
        (click)="navigateBack()"
      />

      <div class="text-center">
        <h4 class="mb-4">
          <span> {{ formGroupUserDetail?.value?.firstName }} </span>

          <span> {{ formGroupUserDetail?.value?.lastName }} </span>
        </h4>
        <h1 class="modal-title mtm-10 mb-0">
          {{ 'USER_ADD_USER' | translate }}
        </h1>
      </div>
      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>

    <div class="d-flex white-nowrap">
      <h2 
      class="heading1 m-auto"
      [ngClass]="{
        'length-sm': getUserAccessHeadingLength() <= 20,
        'length-md': getUserAccessHeadingLength() > 20 && getUserAccessHeadingLength() <= 40,
        'length-lg': getUserAccessHeadingLength() > 40
      }"
    >
      {{ 'ACCESS_DETAIL_USER_ACCESS' | translate }}
    </h2>
    </div>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    {{ errorMessage }}
  </div>
  <div class="detail my-1 py-1 mx-4 text-center">
    <p>
      {{ 'ACCESS_DETAIL_YOUVE_CREATED' | translate }}
      {{ formGroupUserDetail?.value?.firstName }}
      {{ formGroupUserDetail?.value?.lastName }}
      {{ 'ACCESS_DETAIL_LIKE_TO_SHARE_DETAIL' | translate }}
    </p>
  </div>
  <form
    [formGroup]="formGroup"
    tabindex="0"
    (keydown.enter)="submit()"
    #accessDetail
    novalidate
  >
    <div class="scroll-container p-2">
      <div
        *ngIf="!skipStepBuilding && !isPropertyManager"
        class="d-flex building-unit"
      >
        <div>
          <img
            src="/assets/svg/ico-grey-circle-key.svg"
            class="img-key"
            alt="ico-circle-key"
          />
        </div>
        <div class="content" *ngIf="!skipStepBuilding">
          <ng-container *ngIf="!skipStepBuilding">
            <ng-container *ngIf="currentUnits?.length > 0">
              <h3 class="title mb-0">
                <span>
                  {{ currentUnits[0]?.unitName }}
                </span>
              </h3>

              <p class="mb-0 desc">
                <span> {{ currentUnits[0]?.unitName }} </span>,
                {{ currentUnits[0]?.buildingName }}
              </p>
            </ng-container>

            <ng-container *ngIf="currentAccessPoints?.length > 0">
              <h3 class="title mb-0">
                <span>
                  {{ currentAccessPoints[0]?.accessPointName }}
                </span>
              </h3>

              <p class="mb-0 desc">
                <span> {{ currentAccessPoints[0]?.accessPointName }} </span>,
                {{ currentAccessPoints[0]?.buildingName }}
              </p>
            </ng-container>

            <ng-container *ngIf="userGroup?.length > 0">
              <h3 class="mb-0 title">
                <span>
                  {{ currentGroups[0]?.userGroupName }}
                </span>
              </h3>
            </ng-container>

            <ng-container
              *ngIf="
                currentUnits?.length +
                  currentAccessPoints?.length +
                  userGroup?.length >
                  3 ||
                currentUnits?.length > 1 ||
                currentAccessPoints?.length > 1 ||
                userGroup?.length > 1
              "
            >
              <a
                class="see-more"
                href="javascript:void(0)"
                (click)="seeMoreUnitsAndAccessPoints()"
                >{{ 'SEE_MORE' | translate }}</a
              >
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- for PMA/PMU users -->
      <div *ngIf="isPropertyManager" class="d-flex building-unit">
        <div>
          <img
            src="/assets/svg/ico-grey-circle-key.svg"
            class="img-key"
            alt="ico-circle-key"
          />
        </div>
        <div class="content comp-access">
          <ng-container>
            <ng-container>
              <h3 class="title mb-0">
                <span>
                  {{ 'COMPREHENSIVE_ACCESS' | translate }}
                </span>
              </h3>

              <p class="mb-0 desc comp-access-desc">
                {{ 'COMPREHENSIVE_ACCESS_DESC' | translate }}
              </p>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="!isPropertyManager">
        <p class="mb-0 desc text-center font-weight-bold">
          {{ 'ACCESS_TIME' | translate }}
        </p>
        <p class="mb-0 desc text-center font-weight-bold">
          <ng-container *ngIf="!formGroupAccessDetail?.value?.repeat">
            <ng-container *ngIf="!formGroupAccessDetail?.value?.startTime">
              {{ defaultStartTime }}
              <div
                *ngIf="formGroupAccessDetail?.value?.expireTime; else anyTime"
              >
                - {{ formGroupAccessDetail?.value?.expireTime
                  | parsedDateTime : "EEE, MMM do, yyyy 'at' h:mm a"  : "EEE, MMM do, yyyy 'at' h:mm a" }}
              </div>
            </ng-container>
            <ng-container *ngIf="formGroupAccessDetail?.value?.startTime">
              {{ formGroupAccessDetail?.value?.startTime 
                  | parsedDateTime : "EEE, MMM do, yyyy 'at' h:mm a"  : "EEE, MMM do, yyyy 'at' h:mm a"}}
              <div
                *ngIf="formGroupAccessDetail?.value?.expireTime; else anyTime"
              >
                - {{ formGroupAccessDetail?.value?.expireTime 
                  | parsedDateTime : "EEE, MMM do, yyyy 'at' h:mm a"  : "EEE, MMM do, yyyy 'at' h:mm a"}}
              </div>
            </ng-container>
            <ng-template #anyTime>
              <p class="mb-0 desc text-center font-weight-bold">
                {{ 'ANY_TIME' | translate }}
              </p>
            </ng-template>
          </ng-container>
        </p>
        <div
          class="mb-0 desc text-center mx-5 px-1 text-break font-weight-bold"
          *ngIf="formGroupAccessDetail?.value?.repeat"
        >
          {{ formGroupAccessDetail.value?.repeatDays | parsedDateTime : 'EEEE' : "EEEE" }}<span *ngIf="!last">, </span>
          <ng-container
            *ngIf="
              formGroupAccessDetail.value?.repeatStartTime &&
                formGroupAccessDetail.value?.repeatEndTime;
              else repeatdefautTime
            "
          >
            {{ formGroupAccessDetail.value?.repeatStartTime }} -
            {{ formGroupAccessDetail.value?.repeatEndTime }}
          </ng-container>

          <ng-template #repeatdefautTime>
            {{ defaultRepeatStartTime }} -
            {{ defaultRepeatEndTime }}
          </ng-template>
        </div>
      </ng-container>
      <div class="form-group form-container">
        <mat-form-field
          appearance="fill"
          class="w-100 bottom-error-display mb-2 mt-2 primary-input"
        >
          <mat-label>{{ 'ACCESS_DETAIL_EMAIL_ASTERISK' | translate }}</mat-label>
          <input
            matInput
            type="email"
            [placeholder]="'EMAIL' | translate"
            formControlName="email"
          />
          <mat-error *ngIf="formInstance?.email?.errors?.required">
            {{ 'ACCESS_DETAIL_EMAIL_IS_REQURED' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              formInstance?.email?.errors?.email &&
              !formInstance?.email?.errors?.required
            "
          >
            {{ 'PLEASE_ENTER_A_VALID_EMAIL' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group form-container row mb-20">
        <div class="col-3">
          <mat-form-field
            appearance="fill"
            class="bottom-zero mb-2 primary-input w-100"
          >
            <mat-label>{{
              'ACCESS_DETAIL_REGION_ASTERISK' | translate
            }}</mat-label>
            <input matInput placeholder="+1" formControlName="region" />
          </mat-form-field>
        </div>

        <div class="col-8 offset-1">
          <mat-form-field
            appearance="fill"
            class="bottom-zero mb-2 primary-input w-100"
          >
            <mat-label>{{ 'ACCESS_DETAIL_PHONE_ASTERISK' | translate }}</mat-label>
            <input
              matInput
              [placeholder]="'ACCESS_DETAIL_PHONE' | translate"
              formControlName="phone"
              [maxlength]="maxLength"
              type="text"
              id="phone"
              #phone
              [value]="
                formInstance.phone.value
                  | phoneNumberFormat : formInstance.region.value
              "
              (click)="onRegionSelected(formInstance.region.value)"
              (keydown)="onInputBackSpace($event)"
            />

            <mat-error>
              <span *ngIf="formInstance?.phone?.errors?.required">{{
                'ACCESS_DETAIL_PHONE_NUMBER_IS_REQURED' | translate
              }}</span>

              <span *ngIf="formInstance?.phone?.errors?.max">{{
                'ACCESS_DETAIL_PHONE_IS_INVALID' | translate
              }}</span>

              <span
                *ngIf="
                  formInstance?.phone?.errors?.phone &&
                  !formInstance.phone?.errors?.required
                "
                >{{ 'WRONG_PHONE' | translate }}</span
              >
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>

  <div class="row">
    <div class="col-12 my-1 white-nowrap">
      <button
      [ngClass]="{
        'length-sm': getAccessDetailButtonLength() <= 20,
        'length-md': getAccessDetailButtonLength() > 20 && getAccessDetailButtonLength() <= 40,
        'length-lg': getAccessDetailButtonLength() > 40
      }"
      class="btn btn-danger px-3 w-100 btn-submit"
      [disabled]="formGroup.invalid"
      type="submit"
      (click)="submit()"
    >
      {{ 'ACCESS_DETAIL_SHARE_ACCESS_WITH_USER' | translate }}
    </button>
    </div>
  </div>
</div>
